// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1OIis","fileDisabled":"File_fileDisabled__3ASil"};